import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool, utils_tool} from '../../../../tool'
import {columns} from './columns'
import {Descriptions} from 'antd';
import moment from "moment";

let {WizContainer, modelUtils} = framework_tool
let {WizBrowserExport, WizModal, WizCard, WizDataTable, WizButton} = component_tool
let {Session} = utils_tool

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

const _getValue = (type, key) => {
  const values = {
    evaluationPlatform: {
      0: '智联招聘',
      1: '诺姆四达',
    },
    evaluationReason: {
      0: "新开业",
      1: "老店岗位变更",
      2: "未通过重测"
    }
  }
  return values[type][key]
}

class RequirementPersonnelApplyList extends WizContainer {
  componentName = 'requirementPersonnelMessageManager'

  constructor(props) {
    super(props)
    const {history} = props
    let record = {};
    if (history.location && history.location.pathname === '/requirementPersonnel/requirementPersonnelList/apply') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('record', record)
      } else {
        record = Session.get('record') || {}
      }
    }
    this.record = record
    this.filters = {}
    this.state = {
      requirementPersonnelId: record.id,
      applyInfoVisible: false,
      applyData: {}
    }
  }

  _componentDidMount() {
    this._getApplyList();
  }

  _getApplyList = (values = {}) => {
    let {requirementPersonnelId} = this.state;
    if (requirementPersonnelId) {
      this.doAction({
        path: "requirementPersonnelApply/list",
        payload: {
          key: "requirementPersonnelApplyList",
          apiParams: {
            requirementPersonnelId: requirementPersonnelId,
            ...values,
          },
        },
      });
    }
  };

  _getApplyExport = (values = {}) => {
    let {requirementPersonnelId} = this.state;
    if (requirementPersonnelId) {
      this.doAction({
        path: "requirementPersonnelApply/export",
        payload: {
          key: "requirementPersonnelApplyListExport",
          apiParams: {
            requirementPersonnelId: requirementPersonnelId,
            ...values,
          },
        },
      });
    }
  };

  propsAndStateOnChange = {
    requirementPersonnelApplyListExport: this._handleFile.bind(this),
  }

  _handleFile(nextProps, nextState) {
    let o = nextProps.requirementPersonnelApplyListExport
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '测评平台',
        field: 'evaluationPlatform',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '品牌',
        field: 'brandName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '经销商代码',
        field: 'orgCode',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '经销商名称',
        field: 'dealerName',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '证件号码',
        field: 'idCard',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '联系电话',
        field: 'mobile',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '邮箱',
        field: 'email',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '网发经理',
        field: 'evaluationPerson',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '测评事由',
        field: 'evaluationReason',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['evaluationPlatform'] = _getValue('evaluationPlatform', e['evaluationPlatform'])
        e['evaluationReason'] = _getValue('evaluationReason', e['evaluationReason'])
      })
      WizBrowserExport({
        title: '测评报名申请信息',
        sheetName: '测评报名申请信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '测评报名申请信息.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _onLookApplyInfo(record) {
    this.setState({applyInfoVisible: true, applyData: record})
  }

  _renderBtn = () => {
    return <WizButton
      key={'btn_applyInfo' }
      title="导出"
      type="export"
      onClick={() => {
        this._getApplyExport()
      }}
      icon="export"
      style={{marginBottom: 15}}>导出</WizButton>
  }

  _render() {
    let {list} = this.props;
    let {applyInfoVisible, applyData} = this.state
    let dataTableProps = {
      loading: this.props.requirementPersonnelApplyLoading,
      columns: columns(this),
      rowKey: "id",
      dataItems: {},
      dataSource: list.data || [],
      showNum: false,
      isScroll: true,
      pagination: false,
    };

    const items = this.record
    return (
      <React.Fragment>
        <WizCard title={'经销商信息'}>
          <Descriptions column={3} style={{paddingLeft: 25}}>
            <Descriptions.Item label='经销商名称'>{items.dealerName}</Descriptions.Item>
            <Descriptions.Item label='品牌'>{items.brandName}</Descriptions.Item>
            <Descriptions.Item label='预估开业时间'>{formatterDate(items.openTime)}</Descriptions.Item>
            <Descriptions.Item label='销售代码'>{items.preSalesNumber}</Descriptions.Item>
            <Descriptions.Item label='售后代码'>{items.afterSalesNumber}</Descriptions.Item>
          </Descriptions>
        </WizCard>
        <WizCard title={'测评报名记录'}>
          {this._renderBtn()}
          <WizDataTable {...dataTableProps} />
        </WizCard>
        <div style={{position: "fixed", zIndex: 1000}}>
          <WizModal destroyOnClose
                    key={new Date().getTime()}
                    width={750} title={null}
                    footer={null}
                    visible={applyInfoVisible}
                    onOk={() => {
                      this.setState({applyInfoVisible: false})
                    }}
                    onCancel={() => {
                      this.setState({applyInfoVisible: false})
                    }}
          >
            <Descriptions column={2} style={{paddingLeft: 20}} bordered size={"small"}>
              <Descriptions.Item label='姓名'>{applyData.fullName}</Descriptions.Item>
              <Descriptions.Item label='证件号码'>{applyData.idCard}</Descriptions.Item>
              <Descriptions.Item label='联系电话'>{applyData.mobile}</Descriptions.Item>
              <Descriptions.Item label='邮箱'>{applyData.email}</Descriptions.Item>
              <Descriptions.Item label='岗位'>{applyData.positionName}</Descriptions.Item>
              <Descriptions.Item label='品牌'>{applyData.brandName}</Descriptions.Item>
              <Descriptions.Item label='经销商名称'>{applyData.dealerName}</Descriptions.Item>
              <Descriptions.Item label='经销商代码'>{applyData.orgCode}</Descriptions.Item>
              <Descriptions.Item
                label='测评平台'>{_getValue('evaluationPlatform', applyData.evaluationPlatform)}</Descriptions.Item>
              <Descriptions.Item label='网发经理'>{applyData.evaluationPerson}</Descriptions.Item>
              <Descriptions.Item
                label='测评事由'>{_getValue('evaluationReason', applyData.evaluationReason)}</Descriptions.Item>
            </Descriptions>
          </WizModal>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let {requirementPersonnel, requirementPersonnelApply} = state
  const list = modelUtils.getModelEntity(requirementPersonnelApply, "requirementPersonnelApplyList");
  const requirementPersonnelApplyListExport = modelUtils.getModelEntity(requirementPersonnelApply, 'requirementPersonnelApplyListExport');
  const load = modelUtils.getLoadingState(state, ['requirementPersonnel', 'requirementPersonnelApply'])
  return {
    list,
    requirementPersonnelApplyListExport,
    ...load
  }
};

export default connect(mapStateToProps)(RequirementPersonnelApplyList);
